import React, { useState, useEffect } from 'react';

import useAuthorization from 'hooks/useAuthorization';

import DashboardMaster from './roles/master';
import DashboardAdmin from './roles/administrator';
import DashboardExaminer from './roles/examiner';
import DashboardCandidate from './roles/candidate';

import { MASTER, ADMINISTRATOR, EXAMINER, CANDIDATE } from 'utils/roles.js';

const Dashboard = () => {
	const userRole = useAuthorization();

	const [showDashboardMaster, setShowDashboardMaster] = useState(false);
	const [showDashboardAdmin, setShowDashboardAdmin] = useState(false);
	const [showDashboardExaminer, setShowDashboardExaminer] = useState(false);
    const [showDashboardCandidate, setShowDashboardCandidate] = useState(false);

    useEffect(() => {
        if(userRole.length > 0) {
			if ([MASTER].some(role => userRole.includes(role))) { 
                setShowDashboardMaster(true);
				setShowDashboardAdmin(false);
                setShowDashboardExaminer(false);
                setShowDashboardCandidate(false);
            } else if ([ADMINISTRATOR].some(role => userRole.includes(role))) {
                setShowDashboardMaster(false);
				setShowDashboardAdmin(true);
                setShowDashboardExaminer(false);
                setShowDashboardCandidate(false);
            } else if ([EXAMINER].some(role => userRole.includes(role))) {
                setShowDashboardMaster(false);
				setShowDashboardAdmin(false);
                setShowDashboardExaminer(true);
                setShowDashboardCandidate(false);
            } else if ([CANDIDATE].some(role => userRole.includes(role))) {
                setShowDashboardMaster(false);
				setShowDashboardAdmin(false);
                setShowDashboardExaminer(false);
                setShowDashboardCandidate(true);
            }
        }
    }, [userRole]);

    return (
    	<div>
			{ showDashboardMaster && (
                <DashboardMaster />
            )}
            { showDashboardAdmin && (
                <DashboardAdmin  />
            )}
			{ showDashboardExaminer && (
                <DashboardExaminer  />
            )}
            { showDashboardCandidate && (
                <DashboardCandidate  />
            )}
        </div>
  	);
};

export default Dashboard;
